import { render, staticRenderFns } from "./PagedContact.vue?vue&type=template&id=3c43a25c&"
import script from "./PagedContact.vue?vue&type=script&lang=js&"
export * from "./PagedContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports